import { faInfoCircle, faMinus, faPlus } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, IconButton, Tooltip, useTheme } from "@mui/material"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import { flexRender } from "@tanstack/react-table"
import { useState } from "react"
import ClpTable from ".."
import { TableLoadingStateEnum } from "../tableProps.interface"
import { StyledFlexRender, StyledSpan } from "../ClpTable.styled"

const ClpTableRow = (props) => {
  const { row, subColumns, onRowClick, columns } = props
  const [open, setOpen] = useState(false)
  const theme = useTheme()

  const toggleRowOpen = (id) => {
    if (open === id) {
      setOpen(false)
    } else {
      setOpen(id)
    }
  }

  const hasManyColumns = columns?.length > 8

  return (
    <>
      <TableRow
        sx={{
          cursor: onRowClick ? "pointer" : "default"
        }}
        onClick={() => onRowClick && onRowClick(row)}
        key={"row-data-" + row.id}>
        {subColumns && subColumns.length > 0 && (
          <TableCell onClick={(event) => event.stopPropagation()}>
            <FontAwesomeIcon
              style={{
                cursor: "pointer",
                color: theme.palette.secondary.main
              }}
              id={row.id}
              onClick={() => toggleRowOpen(row.id)}
              icon={open === row.id ? faMinus : faPlus}
            />
          </TableCell>
        )}

        {row.getVisibleCells().map((rowCell, index) => {
          const { meta, header, cell, hidden } = rowCell.column.columnDef
          const cellData = rowCell.getValue()
          const isStringAndToLong = typeof cellData === "string" && cellData.length > 30

          return (
            !hidden && (
              <TableCell
                key={index}
                sx={{
                  textAlign: meta?.align
                }}
                data-label={header}>
                {hasManyColumns && isStringAndToLong ? (
                  <StyledSpan>
                    {`${cellData.substring(0, 30)}...`}

                    <Tooltip
                      title={cellData}
                      componentsProps={{
                        tooltip: {
                          sx: {
                            fontSize: "13px"
                          }
                        }
                      }}>
                      <IconButton size="small">
                        <FontAwesomeIcon size={"1x"} icon={faInfoCircle} color={theme.palette.primary[700]} />
                      </IconButton>
                    </Tooltip>
                  </StyledSpan>
                ) : (
                  <StyledFlexRender>{flexRender(cell, rowCell.getContext())}</StyledFlexRender>
                )}
              </TableCell>
            )
          )
        })}
      </TableRow>
      {open === row.id && row.original.subRows && (
        <TableRow>
          <TableCell colSpan={12}>
            <Box>
              <ClpTable
                rows={row.original.subRows}
                columns={subColumns}
                loadingState={TableLoadingStateEnum.Success}
              />
            </Box>
          </TableCell>
        </TableRow>
      )}
    </>
  )
}

export default ClpTableRow
